import { render, staticRenderFns } from "./AdPrototype.vue?vue&type=template&id=4efca200&scoped=true"
var script = {}
import style0 from "./AdPrototype.vue?vue&type=style&index=0&id=4efca200&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4efca200",
  null
  
)

export default component.exports